import React, { useEffect, useState, useRef, Children, isValidElement, cloneElement } from 'react';

const FadeInUp = ({ children, delay = 0 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setIsVisible(true), delay);
                    observer.disconnect();
                }
            });
        });

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [delay]);

    return (
        <>
            {Children.map(children, (child, index) => {
                if (!isValidElement(child)) return child;

                const props = {
                    className: `${child.props.className || ''} fade-in-up ${isVisible ? 'fade-active' : ''}`.trim(),
                    ...(index === 0 ? { ref } : {})
                };

                return cloneElement(child, props);
            })}
        </>
    );
};

export default FadeInUp;
